import './Icon.css';

export default function Icon({ className, children, ...props }) {
  return (
    <span className={`material-icons ${className || ''}`} {...props}>
      {children}
    </span>
  );
}
